import { Order } from '@cemex-core/cmx-api';
import { State } from '@cemex/cmx-client-layout';
import { Store } from '@ngrx/store';
import { take } from 'rxjs/operators';
import { OneClickUpdateOrderAction } from '../../actions/one-click-orders.actions';
import { getOneClickSelectedOrder } from '../../selectors/one-click-orders.selector';

export function setContractInOrder(value, store: Store<State>, index: number) {
  store
    .select(getOneClickSelectedOrder)
    .pipe(take(1))
    .subscribe((order) => {
      const modded: Order = {
        ...order,
        items: order.items.map((item, i) => {
          if (index === i) {
            return {
              ...item,
              agreementItem: value ? { ...item.agreementItem, agreementItemId: value } : undefined,
            };
          } else {
            return item;
          }
        }),
      };

      store.dispatch(new OneClickUpdateOrderAction(modded));
    });
}
